import { useCurrentInventoryId } from "../url";
import { useInventoryDatabases } from "./useDatabases";
import { useCallback } from "react";
import { usePouchBulkChange } from "./usePouchBulkChange";
import { filterUndefined } from "../../utils/utils";
import { InventoryObject } from "./useCurrentObject";

export function useDeleteObject() {
  const { inventoryId } = useCurrentInventoryId();
  const { inventory } = useInventoryDatabases();

  const {
    execute: executeImpl,
    working,
    error,
  } = usePouchBulkChange(inventory, inventoryId === undefined ? [] : [`inventory:${inventoryId}`]);

  const execute = useCallback(
    async (object: InventoryObject) => {
      return await executeImpl([
        // replace form objects by their ID, undoing what's being done in `useCurrentObject`
        {
          ...object,
          data: filterUndefined(object.data.map((f) => f._id)),
          _deleted: true,
        },
        ...object.data.map((f) => ({ ...f, _deleted: true })),
      ]);
    },
    [executeImpl]
  );

  return {
    execute,
    working,
    error,
  };
}
